export enum ErrorCodes {
  IncorrectRequestType = 'INCORRECT_REQUEST_TYPE',
  AccessRestricted = 'ACCESS_RESTRICTED',
  UnAuthorised = 'UN_AUTHORISED',
  UrlNotFound = 'URL_NOT_FOUND',
  NoContent = 'NO_CONTENT',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidInputs = 'INVALID_INPUTS',
  NotFound = 'NOT_FOUND',
  RecordDeleted = 'RECORD_DELETED',
  RecordArchived = 'RECORD_ARCHIVED',
  TimesheetApproved = 'TIMESHEET_APPROVED',
  CustomDomainFailure = 'CUSTOM_DOMAIN_FAILURE',
  EmailDomainFailure = 'EMAIL_DOMAIN_FAILURE',
  TokenInvalid = 'TOKEN_INVALID',
  AttachmentSizeExceeded = 'ATTACHMENT_SIZE_EXCEEDED',
  IntegrationSettingsInvalidInput = 'INTEGRATION_SETTINGS_INVALID_INPUT',
  IntegrationSettingsBadState = 'INTEGRATION_SETTINGS_BAD_STATE',
  ConflictingFieldValue = 'CONFLICTING_FIELD_VALUE',
  PaymentFailed = 'PAYMENT_FAILED',
  LimitReached = 'LIMIT_REACHED',
  InvalidOtp = 'INVALID_OTP',
  NoSlackIntegrationsFound = 'NO_SLACK_INTEGRATIONS_FOUND',
  NoWebhooksFound = 'NO_WEBHOOKS_FOUND',
  NoSFIntegrationsFound = 'NO_SF_INTEGRATIONS_FOUND',
}
